import { useForm } from "@mantine/form";
import { FormData2, RowsConfig2, CashflowRowItem } from "./GenericTable";
import { Button } from "@mantine/core";

export function ItemForm2<TItem extends CashflowRowItem>({
  config,
  onSubmit,
  item,
}: {
  config: RowsConfig2<TItem>["form"];
  onSubmit: (x: FormData2) => void;
  item: TItem | undefined;
}) {
  const form = useForm<FormData2>({
    initialValues: item ? config.getInitialValue(item) : undefined, // make this better for new form items?
    // validate: config.validate,
  });

  return (
    <form
      onSubmit={form.onSubmit((values) => {
        onSubmit(values);
      })}
    >
      {config.renderFields(form)}
      <Button type="submit">Save</Button>
    </form>
  );
}
